import React, { FC, useEffect, useRef, useState } from "react";

// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl';


import { get, post } from "../../fetchers/fetchers";
import {
    IDam, IDamsList
} from "../../types/types";

import {
    Accordion,
    AccordionSummary,
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, TextField
} from "@material-ui/core";



mapboxgl.accessToken = 'pk.eyJ1IjoiY2hyaXN0aWFudXJpY2giLCJhIjoiY2tpaWx2dnZpMDN5YTJ5cDBxajNibjBtNSJ9.sd3Q-4QrSLopA-WTs0Fc2g';

interface IOverviewProps {
    dams: IDamsList[]

}

const Map: FC<IOverviewProps> = ({ dams }) => {

    const mapContainer = useRef<any>(null);
    const map = useRef<any>(null);
    const [lng, setLng] = useState(150.373);
    const [lat, setLat] = useState(-32.457);
    const [zoom, setZoom] = useState(5);
    //const [update, setUpdate] = useState(false);


    useEffect(() => {

        // if map already exists, remove it
        if (map.current) {
            map.current.remove();
        }

        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [lng, lat],
            zoom: zoom
        })

        // Create a default Marker and add it to the map.

        dams.map(d => {

            // check if longitude and latitude are available
            if (d.dam.longitude && d.dam.latitude) {
                const marker = new mapboxgl.Marker({
                    draggable: false,
                    color: '#ff0000'
                })
                    .setLngLat([d.dam.longitude, d.dam.latitude])
                    .addTo(map.current);
            }
        })

    })

    return (
        <>
            <Paper variant={"outlined"} style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>

                <div>
                    <div ref={mapContainer} style={{ "height": "500px" }} />
                </div>


            </Paper>
        </>
    );
}

export default Map;
